/**
 * CheTuo Web — Auth state hook (Zustand).
 */

import { create } from 'zustand';
import { tokenStorage } from '../api/client';

export interface AuthUser {
  id: string;
  phone: string;
  displayName: string | null;
  isSuperAdmin: boolean;
}

interface AuthState {
  user: AuthUser | null;
  isLoggedIn: boolean;
  login: (token: string, user: AuthUser) => void;
  logout: () => void;
  restore: () => void;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  isLoggedIn: false,
  login: (token, user) => {
    tokenStorage.setToken(token);
    tokenStorage.setUser(user);
    set({ user, isLoggedIn: true });
  },
  logout: () => {
    tokenStorage.clearToken();
    tokenStorage.clearShopId();
    set({ user: null, isLoggedIn: false });
  },
  restore: () => {
    const token = tokenStorage.getToken();
    const user = tokenStorage.getUser<AuthUser>();
    if (token && user) {
      set({ user, isLoggedIn: true });
    }
  },
}));
